<template>
    <div class="cms-generic-placeholder">
        <div v-for="(plugin, pluginIdx) in plugins" :class="getPluginClassName(plugin)" :key="pluginIdx">
            <cms-generic-plugin :type="plugin.type" v-bind="bindCmsPluginAttrs(plugin)"/>
        </div>
    </div>
</template>

<script>
    import { bindCmsPluginAttrs } from 'util/vue/django-cms-spa';
    import { mapFacets } from 'util/misc/facets';
    import CmsGenericPlugin from 'framework/components/cms/cms-generic-plugin/cms-generic-plugin';
    import cmsPlaceholderMixin from 'framework/mixins/cms/cms-placeholder';

    export default {
        components: { CmsGenericPlugin },
        mixins: [
            cmsPlaceholderMixin,
        ],

        methods: {
            bindCmsPluginAttrs,
            getPluginClassName(plugin) {
                return [
                    'cms-generic-placeholder--plugin',
                    ...mapFacets('cms-generic-placeholder--plugin', [plugin.type]),
                ];
            },
        },
    };
</script>
